import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';
// import { pullAll } from 'lodash';

const namespaced = true;

const state = {
  token: '',
  refreshToken: '',
  user: {},
  student: null,
  googleAuth: '',
  guidePopUp: false
};

const getters = {
  isAuthenticated: state => !!state.token,
  permission: state => jwtDecode(state.token)?.permission ?? [],
  googleAuth: state => state.googleAuth,
  token: state => state.token,
  refreshToken: state => state.refreshToken,
  user: state => state.user,
  student: state => state.student,
  guidePopUp: state => state.guidePopUp,
  currentEmail: state => {
    if (!state.token) return;
    let decoded = jwtDecode(state.token);
    return decoded.sub;
  },
  currentId: state => {
    if (!state.user?.userId) return;
    return state.user?.userId;
  },
  currentRole: state => {
    if (!state.user?.roleId) return;
    return state.user?.roleId;
  },
  currentSchool: state => {
    if (!state.user?.schoolId) return;
    return state.user?.schoolId;
  },
  currentVerified: state => {
    if (!state.user?.verified) return;
    return state.user?.verified;
  }
};

const mutations = {
  SET_GUIDE_POP: (state, payload) => {
    state.guidePopUp = payload.guidePopUp;
  },
  SET_GOOGLE_AUTH: (state, payload) => {
    state.googleAuth = payload;
  },
  SET_GOOGLE_AUTH_CLEAR: state => {
    state.googleAuth = null;
  },
  SET_TOKEN: (state, payload) => {
    state.token = payload;
  },
  SET_REFRESH_TOKEN: (state, payload) => {
    state.refreshToken = payload;
  },
  SET_USER: (state, payload) => {
    state.user = { ...state.user, ...payload };
  },
  CLEAR_USER: state => {
    state.user = {};
  },
  SET_STUDENT: (state, payload) => {
    state.student = { ...state.student, ...payload };
  },
  CLEAR_STUDENT: state => {
    state.student = null;
  }
};

const actions = {
  async setAuth({ commit }, payload) {
    try {
      commit('SET_GOOGLE_AUTH', payload);
      return Promise.resolve(payload);
    } catch (err) {
      throw err;
    }
  },
  async loginGoogle({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.post('api/auth/login-google', { ...payload, deviceType: 0 });
      commit('SET_USER', data);
      commit('SET_TOKEN', data.token);
      commit('SET_REFRESH_TOKEN', data.refreshToken);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  async login({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.post('api/auth/login', { ...payload, deviceType: 0 });
      commit('SET_USER', data);
      commit('SET_TOKEN', data.token);
      commit('SET_REFRESH_TOKEN', data.refreshToken);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  register({ rootGetters }, payload) {
    let masterSchool;
    if (payload.schoolName) {
      masterSchool = {
        address: payload.address,
        cityId: payload.cityId,
        educationalLevel: payload.educationalLevel,
        schoolName: payload.schoolName,
        schoolNumber: payload.schoolNumber
      };
    }
    return window.axios.post(`api/auth/register`, {
      ...payload,
      masterSchool
    });
  },
  async refresh({ state, commit }) {
    try {
      const {
        data: { data }
      } = await window.axios.get('api/auth/refresh', {
        headers: {
          Authorization: `Bearer ${state.refreshToken}`
        }
      });
      commit('SET_USER', data);
      commit('SET_TOKEN', data.token);
      commit('SET_REFRESH_TOKEN', data.refreshToken);
      commit('SET_GUIDE_POP', false);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  async verifyDeleteAccount(_, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.post('api/auth/verify-delete-account', payload);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },
  async logout({ commit }) {
    try {
      await window.axios.delete('api/auth/logout', {
        headers: { 'Device-id': '' }
      });
      commit('CLEAR_USER');
      commit('CLEAR_STUDENT');
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_GUIDE_POP', false);
      Cookies.remove('vuex');
      localStorage.removeItem('timeQuiz');
      localStorage.setItem('LANG', 'en');
    } catch (err) {
      throw err;
    }
  },
  async clearSession({ commit }) {
    try {
      commit('CLEAR_USER');
      commit('CLEAR_STUDENT');
      commit('SET_TOKEN', '');
      commit('SET_REFRESH_TOKEN', '');
      commit('SET_GUIDE_POP', false);
      Cookies.remove('vuex');
      localStorage.removeItem('timeQuiz');
      localStorage.setItem('LANG', 'en');
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
